import React          from 'react'
import { withRouter } from 'react-router'
import { Alert      } from 'react-bootstrap'

import { authMessageFromQS } from 'alto-react-base-auth/lib/utils'
import { LoginLink         } from 'alto-react-base-auth/lib/routes'

import './auth_message.sass'

class AuthMessage extends React.Component
  constructor: ->
    super()

    @state = { qs: '', message: '', messageType: '', dismissed: false }

  @getDerivedStateFromProps: (props, state) ->
    qs = props.location.search

    if qs == state?.qs
      null
    else
      { message, messageType } = authMessageFromQS(qs)

      { qs, message, messageType: messageType or 'info', dismissed: false }

  componentDidMount: ->
    @setDismissTimeout() if @state.message

  componentDidUpdate: (prevProps, prevState) ->
    if @dismissTimeout and (@state.dismissed or @state.message != prevState.message)
      @clearDismissTimeout()

    if @state.message and @state.message != prevState.message
      @setDismissTimeout()

  componentWillUnmount: ->
    @clearDismissTimeout()

  setDismissTimeout: ->
    @dismissTimeout = setTimeout((=> @dismissTimeout = null; @setState(dismissed: true)), 20000)

  clearDismissTimeout: ->
    if @dismissTimeout
      clearTimeout(@dismissTimeout)
      @dismissTimeout = null

  render: ->
    if @state.message and not @state.dismissed
      <Alert className='auth-message right' bsStyle={@state.messageType}
             onDismiss={=> @setState(dismissed: true)}>
        {@messages()[@state.message]}
      </Alert>
    else
      null

  messages: ->
    activation_email_sent:
      <p>
        Byl Vám zaslán aktivační email. Registraci dokončíte kliknutím na odkaz, který v něm najdete.
      </p>
    activation_successful:
      <p>Aktivace byla úspěšná, nyní se můžete <LoginLink>přihlásit</LoginLink>.</p>
    activation_email_resending_successful:
      <p>Aktivační email byl odeslán na Vaši emailovou adresu.</p>
    password_reset_initiated:
      <p>
        Byl Vám odeslán email pro reset zapomenutého hesla.
        Změnu dokončíte kliknutím na odkaz, který v něm najdete.
      </p>
    password_reset_successful:
      <p>Vaše heslo bylo úspěšně resetováno. Nyní se můžete <LoginLink>přihlásit</LoginLink>.</p>
    password_change_successful:
      <p>Vaše heslo bylo úspěšně změněno.</p>
    account_delete_successful:
      <p>Váš účet byl úspěšně smazán.</p>
    session_expired:
      <p>Byli jste odhlášeni z důvodu neaktivity. Přihlaste se prosím znovu.</p>

export default withRouter(AuthMessage)
